/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { EventsType } from 'cio/utils/analytics/events';
import AnalyticsService from 'cio/services/analytics';
import { EventProperties } from 'cio/services/analytics';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ApiService from 'cio/services/api';
import { dropTask } from 'ember-concurrency';
import CampaignModel from 'cio/models/campaign';
import TemplateModel from 'cio/models/template';

type EmailSuggestion = {
  email?: string;
  used_fallback?: boolean;
};

interface Signature {
  Element: HTMLDivElement;
  Args: {
    campaign: CampaignModel;
    template: TemplateModel;
    isLiquidAiEnabled: boolean;
  };
}

export default class GenerateLiquidWithAi extends Component<Signature> {
  @service analytics!: AnalyticsService;
  @service api!: ApiService;

  @tracked refinement = '';
  @tracked generatedTitle = '';
  @tracked generatedBody = '';
  @tracked lastSuccessfulEmailValue = '';

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    if (this.args.isLiquidAiEnabled) {
      this.loadSuggestion.perform();
    }
  }

  @action
  onCopy(name: keyof EventsType['objects_liquid']) {
    this.trackEvent(name);
  }

  @action
  trackSuggestion(refine?: boolean) {
    let name: keyof EventsType['objects_liquid'];
    let data: Record<string, any> = {};
    if (refine !== undefined && refine === true) {
      name = 'adjust_clicked';
      data.adjustment = this.refinement;
    } else {
      name = 'generate_clicked';
    }
    this.trackEvent(name, { data });
  }

  @action
  trackEvent(name: keyof EventsType['objects_liquid'], eventData?: EventProperties) {
    let data = {
      campaign: this.args.campaign,
      channel: this.args.template?.templateType,
      ...eventData,
    };
    this.analytics.track('objects_liquid', name, { data });
  }

  loadSuggestion = dropTask(async (refine?: boolean) => {
    let response: EmailSuggestion = {};

    this.trackSuggestion(refine);

    try {
      if (refine === true) {
        // Refine
        response = await this.api.post('completion/refine-email', {
          ignoreErrors: true,
          data: {
            campaign_id: this.args.campaign.id,
            email: this.lastSuccessfulEmailValue ?? '',
            refinement: this.refinement,
          },
        });
      } else {
        // Generate
        response = await this.api.post('completion/generate-email', {
          ignoreErrors: true,
          data: { campaign_id: this.args.campaign.id },
        });
      }

      if (response.email != null) {
        let { email } = response;
        let [subject, ...rest] = email.slice(email?.indexOf('Subject:')).split('\n\n');
        this.generatedBody = rest.join('\n\n');
        this.generatedTitle = subject.split('Subject: ')[1];
        this.refinement = '';
      }
    } catch (e) {}

    if (response.email != null) {
      this.lastSuccessfulEmailValue = response.email;
    }

    return response;
  });
}
